import logo from './logo.svg'
import { useState } from "react";
import './App.css';
import Flags from './Flags';

function App() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const isMobile =
      ("ontouchstart" in window || navigator.maxTouchPoints > 0) &&
      window.matchMedia("(max-width: 768px)").matches;

    const handleClick = () => {
      if (!email.trim()) {
        alert("Please enter your email.");
        return;
      }
      // Basic HTML5-style check
      const isValid = /^\S+@\S+\.\S+$/.test(email);
      if (!isValid) {
        alert("Please enter a valid email address.");
        return;
      }

      // You can send `email` to your backend here if needed

      window.open("https://www.startkbeauty.com", "_blank", "noopener,noreferrer");
    };

    const awards = [
        { img: "/images/awards/1.png", title: "2022 KCAB Korea Consumer Appraisal Brand's No.1 Brand", sub1: "Organizer: Dong-A Ilbo" },
        { img: "/images/awards/2.png", title: "2022 Women Consumer's Choice Premium Brand Top Prize" },
        { img: "/images/awards/3.png", title: "2021 Women Consumer's Choice Premium Brand Top Prize", sub1: "[Skincare Product Category: INCELLDERM]", sub2: 'Host: Weekly Donga' },
        { img: "/images/awards/4.png", title: "2021 Korea Brand Power No.1 Functional Cosmetic - INCELLDERM", sub1: "Organizer:Korea Premium Brand Association" },
        { img: "/images/awards/5.png", title: "2021 Nation's Consumer Driven Brand Top Prize Functional Cosmetic - INCELLDERM", sub1: "Organizer: Dong-A Ilbo" },
        { img: "/images/awards/6.png", title: "2020 Korea Brand Power No.1", sub1: "Host: Korea Premium Brand Association" },
        { img: "/images/awards/7.png", title: "2020 Nation's Consumer Driven Nation's Consumer Driven Brand Top Prize", sub1: "Host: Dong-A Ilbo" },
        { img: "/images/awards/8.png", title: "2020 Korea Consumer Preference Brand Award Top Prize", sub1: "Host: Sports Seoul", sub2: "Organizer: Korea Media Research" },
        { img: "/images/awards/9.png", title: "2020 Women Consumer's Choice Premium Brand Top Prize", sub1: "Organizer: Hankyung Business Gvalley News" },
        { img: "/images/awards/10.png", title: "2019 Women Consumer's Choice Premium Brand Top Prize", sub1: "Organizer: Hankyung Business Gvalley News" },
        { img: "/images/awards/11.png", title: "2018 Women Consumer's Choice Premium Brand Top Prize", sub1: "Organizer: Hankyung Business Gvalley News" },
    ];

    const flags = [
        { src: "/images/flags/canada.jpg", alt: "Canada" },
        { src: "/images/flags/taiwan.jpg", alt: "Taiwan" },
        { src: "/images/flags/hongkong.jpg", alt: "Hongkong" },
        { src: "/images/flags/malaysia.jpg", alt: "Malaysia" },
        { src: "/images/flags/singapore.jpg", alt: "Singapore" },
        { src: "/images/flags/philippines.jpg", alt: "Philippines" },
        { src: "/images/flags/uk.jpg", alt: "United Kingdom" },
        { src: "/images/flags/japan.jpg", alt: "Japan" },
        { src: "/images/flags/south_korea.jpg", alt: "South Korea" }
    ];


    const submitEmail = async (e) => {
      e.preventDefault();

      const form = new FormData();
      form.append("email", email);

      try {
        setLoading(true);

        const res = await fetch("http://whyriman.info/api/save.php", {
          method: "POST",
          body: form,
        });

        const data = await res.json().catch(() => null);

        if (!res.ok || !data?.ok) {
          alert('Failed to save email address. Please try again later.')
          return;
        }
        setLoading(false);
        setEmail("");
        
        const url = "https://www.startkbeauty.com";
        //window.open("https://www.startkbeauty.com", "_blank", "noopener,noreferrer")
        if (isMobile) {
          window.location.assign(url); // same tab
        } else {
          window.open(url, "_blank", "noopener,noreferrer"); // new tab
        }
      
      } catch (err) {
        setLoading(false);
        alert('Failed to save email address. Please try again later.')
      } finally {
        setLoading(false);
      }

    };

  function FullPageLoader() {
    return (
      <div className="page_loader" role="status" aria-live="polite" aria-busy="true">
        <div className="spinner" />
      </div>
    );
  }
  

  return (
    <div className="App">
      {loading && <FullPageLoader />}

      <div className="wrapper">
          <h1>"An Opportunity to Partner <br />
            with a Billion-Dollar Company"
          </h1>

          <h2>Take advantage of the booming KBeauty Revolution <br /> A Legitimate Business Opportunity to Build Real Income!</h2>

          <div className='seperator'></div>
          <div className='video_wrapper'>
            <iframe
              src={`https://www.youtube.com/embed/7AQOB71OELA?rel=0`}
              title="YouTube video player"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>

          <div className="countries_container">
            <h2>Open to 11 countries and counting...</h2>
            <div className="flags_wrapper">
              {/* {flags.map((a, idx) => (
                  <div className="flags_item" key={`g1-${idx}`}>
                      <img src={a.img} alt={a.title} />
                  </div>
              ))} */}
              <Flags images={flags} />
            </div>
          </div>
      </div>

      <div id="awards_section" className="awards_section">
        <div className="content_wrapper">
            <div className="awards_marquee">
            <div className="awards_track">
                <div className="awards_group">
                {awards.map((a, idx) => (
                    <div className="awards_item" key={`g1-${idx}`}>
                        <img src={a.img} alt={a.title} />
                        <h3>{a.title}</h3>
                        {
                            a.sub1 && <h4>{a.sub1}</h4>
                        }
                        {
                            a.sub2 && <h4>{a.sub2}</h4>
                        }
                    </div>
                ))}
                </div>

                <div className="awards_group" aria-hidden="true">
                {awards.map((a, idx) => (
                    <div className="awards_item" key={`g2-${idx}`}>
                        <img src={a.img} alt="" />
                        <h3>{a.title}</h3>
                        {
                            a.sub1 && <h4>{a.sub1}</h4>
                        }
                        {
                            a.sub2 && <h4>{a.sub2}</h4>
                        }
                    </div>
                ))}
                </div>
            </div>
            </div>
          </div>
        </div>

      <div className='sub_header'>
          <h3>EXPERIENCE THE POWER OF RIMAN RITUALS</h3>
          <h4>No Need To Go To Korea - The #1 KBeauty Brand in Korea is now in the Philippines</h4>
      </div>
      <div className='video_container'>
        <div className='video_wrapper'>
          <iframe
            src={`https://www.youtube.com/embed/6l5B6LLbEiM?rel=0`}
            title="YouTube video player"
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
        <div className='video_wrapper'>
            <iframe
              src={`https://www.youtube.com/embed/P9JzW8t5V4A?rel=0`}
              title="YouTube video player"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
      </div>
      
      <div className='sub_header2'>
          <h4>We love to give you some tips about Korean Skincare Rituals</h4>
          <h4>and how you can be part of our KBeauty community...</h4>
      </div>

      <div className='messageme_btn_wrapper'>
        <div>
          <form onSubmit={submitEmail} className='messageme_btn_content'>
            <input
              className="email_input"
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button type="submit">
                Learn More
            </button>
          </form>
        </div>
      </div>

      <div className='footer_wrapper'>
          <div className='left'>
              Copyright - All Rights Reserved 2026  
          </div>
          <div className='right'>
              Queen Boss Society | King Boss Club
          </div>
      </div>
    </div>
  );
}

export default App;
